import "../_namespaces.js";
import "../models/response.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Collections ??= {};

AssessmentViewer.Collections.Responses = class Responses extends Backbone.Collection {
  constructor() {
    super(...arguments);
    this.selected = this.selected.bind(this);
    this.firstSelected = this.firstSelected.bind(this);
  }

  selected() {
    return this.where({ selected: true });
  }

  firstSelected() {
    return this.findWhere({ selected: true });
  }
};
AssessmentViewer.Collections.Responses.prototype.model = AssessmentViewer.Models.Response;
